module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('option-general', {
    attrs: {
      "value": "time",
      "label": _vm.$t('edit.sidebar.by_time_on_page')
    }
  }, [_c('div', {
    staticClass: "box-input-group box-input-time"
  }, [_c('i', {
    staticClass: "box-input-group__icon icon-kp-clock"
  }), _vm._v(" "), _c('input', {
    staticClass: "box-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.boxConfig.advanced.exibition_mode_time_value
    },
    on: {
      "change": function($event) {
        return _vm.boxUpdateConfig({
          item: 'advanced',
          key: 'exibition_mode_time_value',
          value: $event.target.value
        });
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "box-input-group-label"
  }, [_vm._v(_vm._s(_vm.$t('general.labels.seconds')))])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-13f99b5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/advancedconfig/exibitionmode/options/Time.vue
 ** module id = 770
 ** module chunks = 1
 **/